<template>
  <button
    :aria-label="params.label"
    :class="[editableClass, params.className]"
    :title="params.label"
    :v-tooltip="params.tooltip || false"
    @click="$event => clickHandler($event)"
    class="ag-grid-button material-icons"
    v-if="params.icon && !params.hide"
    >{{params.icon}}</button>
  <p-button
    :class="[editableClass, params.className]"
    :v-tooltip="params.tooltip || false"
    @click="clickHandler"
    class="ag-grid-button"
    v-else-if="params.visible"
    >{{params.label || 'button'}}</p-button>
</template>
<script lang="ts">
import type { PropType } from 'vue';

export default {
  props: {
    params: {
      type: Object as PropType<Record<string, any>>,
      default: () => ({}),
    }
  },
  computed: {
    editableClass() {
      return (!Object.hasOwnProperty.call(this.params, 'editable') || this.params.editable) ? 'cursor-pointer' : '';
    },
  },
  methods: {
    clickHandler($event?: MouseEvent) {
      this.params.clicked({ $event, value: this.params.value });
    },
  },
};
</script>
